// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--A9iq7";
export var nav = "footer-module--nav--VRQgc";
export var socialNav = "footer-module--socialNav---oBx8";
export var socials = "footer-module--socials--04+db";